'use client'

import _ from 'lodash'
import { ListBox } from '@/components'
import { lookup } from '@cruz-com/lookup'

type Props = {
  sortId: number | string
  onSortIdChanged: (val: any) => void
}

export function VehicleFilter2Min({ sortId, onSortIdChanged }: Props) {
  return (
    <div className='vehicle-s2-filter'>
      <div className='flex items-center gap-x-3'>
        <label className='vehicle-s2-label'>Sort By:</label>
        <ListBox inline={true} className='min-w-[200px]'
          option={lookup.vehicle.sortOption}
          value={_.toNumber(sortId)}
          onChange={val => { onSortIdChanged(val) }}
        />
      </div>
    </div>
  )
}